/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function TableInsertRowBelowX({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#TableInsertRowBelowX_svg__a)"><path fillRule="evenodd" d="M.775 2.875a2.6 2.6 0 0 1 2.6-2.6h9a2.6 2.6 0 0 1 2.6 2.6v5.5a.6.6 0 1 1-1.2 0v-.9h-11.8v.9a.6.6 0 0 1-1.2 0v-5.5Zm1.2 3.4h11.8v-3.4a1.4 1.4 0 0 0-1.4-1.4h-9a1.4 1.4 0 0 0-1.4 1.4v3.4Z" clipRule="evenodd" /><path d="M1.375 10.025a.6.6 0 0 0-.6.6v1a1.6 1.6 0 0 0 1.6 1.6h.5a.6.6 0 1 0 0-1.2h-.5a.4.4 0 0 1-.4-.4v-1a.6.6 0 0 0-.6-.6ZM12.875 13.225a.6.6 0 1 1 0-1.2h.5a.4.4 0 0 0 .4-.4v-1a.6.6 0 1 1 1.2 0v1a1.6 1.6 0 0 1-1.6 1.6h-.5ZM5.892 10.6a.577.577 0 0 0 0 .815l1.292 1.292-1.292 1.292a.577.577 0 1 0 .816.816L8 13.523l1.292 1.292a.577.577 0 1 0 .816-.816l-1.292-1.292 1.292-1.292a.577.577 0 1 0-.816-.816L8 11.891 6.708 10.6a.577.577 0 0 0-.816 0Z" /></g><defs><clipPath id="TableInsertRowBelowX_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;